<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M39.51 10.2l-9.33-3.13a2 2 0 00-1 0L18.33 10 9.51 7.07A2 2 0 007 9v26.86a2 2 0 001.49 1.94l9.33 3.13a2 2 0 001 0L29.67 38l8.82 2.93A2 2 0 0041 39V12.14a2 2 0 00-1.49-1.94zm-20.18 2.64l9.34-2.53v24.85l-9.34 2.53zM10 10.3l7.33 2.52v24.8L10 35.09zm28 27.4l-7.33-2.52v-24.8L38 12.91z"/></svg>